export const redirect = (url) => {
  setTimeout(() => {
    try {
      window.location.href = url;
    } catch (e) {
      window.location = url;
    }
  }, 250);
};
